export default __webpack_public_path__ + "static/media/Нэгдсэн уулзалт хувьсах зардал, цалин хөлс.b469ab90.pdf";